<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-produto') {
            next({ name: 'ven-produto-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-produto') {
            this.$router.push({ name: 'ven-produto-list' });
        }
    },
};
</script>
